
export const formatNumber = (v:number|undefined, unit:string|undefined) : string => {
    const value = typeof(v) === "number" ? v : 0;
    if (typeof(unit)==="string" && unit.toLowerCase().includes("byte"))
        return "0x" + value.toString(16);
    return value+"";
};

export const formatEmpty = (unit: string | undefined) => {
    if (typeof(unit)==="string" && unit.toLowerCase().includes("byte"))
        return "0x0";
    return "0";
}